// extracted by mini-css-extract-plugin
export default {"container":"WithdrawFunds_container__0-WiX","label":"WithdrawFunds_label__X5roa","customInput":"WithdrawFunds_customInput__TKUlb"};